<template>
  <div>
    <!-- Delete Chat Dialog -->
    <v-dialog v-model="deleteDialog" max-width="300" flat elevation="0">
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
        <v-card-title class="justify-center">
          <h5 class="defaultColor--text font-weight-regular text-center">
            {{ $t("description.deleteChat") }}
          </h5>
        </v-card-title>
        <v-card-actions class="justify-center align-center py-5">
          <v-btn
            color="defaultColor"
            class="white--text text-capitalize"
            block
            elevation="0"
            rounded
            large
            @click="deleteChat()"
          >
            {{ $t("buttons.yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="deleteDialog = false" />
    </v-dialog>

    <!-- New Chat Dialog -->
    <v-dialog
      v-model="newChat"
      width="550"
      scrollable
      @click:outside="closeNewChatDialog()"
    >
      <v-card
        max-width="550"
        height="600"
        style="max-height: 600px"
        class="rounded-lg"
      >
        <v-card-title class="lighten-2 textDefaultColor justify-center">
          <v-layout column>
            <h3 class="mb-4 ml-2">Yeni Sohbet</h3>
            <v-text-field
              v-model="newChatUserModel"
              :disabled="newChatLoading"
              :label="$t('description.messageUserSearch')"
              color="defaultColor"
              class="mb-3"
              v-on:keyup.enter="newChatSetUser"
              hide-details
              outlined
              rounded
            >
              <template v-slot:append>
                <v-btn
                  text
                  :disabled="newChatUserModel.length < 3"
                  :loading="newChatLoading"
                  color="defaultColor"
                  @click="newChatSetUser"
                  class="text-capitalize"
                  style="margin-top: -7px"
                >
                  {{ $t("buttons.search") }}
                </v-btn>
              </template>
            </v-text-field>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <!-- <loading-progress :status="loadingList" v-if="users.length <= 0" /> -->
        <v-card-text class="px-0">
          <div id="scrollView">
            <v-list subheader two-line class="pa-0">
              <div v-for="(item, index) in newChatUsers" :key="index">
                <user-list-item
                  :item="item"
                  :avatar="item.Avatar"
                  :fullName="item.FullName"
                  :department="item.Department"
                  :userId="item.Id"
                  :company="item.Company"
                  :buttonText="'Mesaj Gönder'"
                  @sendMessage="(n) => createNewChat(n)"
                  :buttonVisible="true"
                  :noGotoProfile="true"
                  :noBg="true"
                  :divider="true"
                />
              </div>
            </v-list>
          </div>
        </v-card-text> </v-card
    ></v-dialog>

    <!-- Main Chat Container -->
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-space-around mt-0 pb-5>
        <!-- Search -->
        <v-flex xs12 md12 pb-0>
          <v-card
            class="messageCardClass"
            style="
              background-color: transparent !important;
              border: 0px solid red !important;
            "
            flat
          >
            <v-card-title
              class="text-center pt-6 pb-0 justify-center align-center"
            >
              <!-- clearable
                clear-icon="mdi-close-circle"
                @click:clear="clearSearch" -->
              <v-text-field
                v-model="searchTextModel"
                :label="$t('description.messageUserSearch')"
                color="defaultColor"
                outlined
                rounded
              >
              </v-text-field>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                icon
                color="defaultColor"
                @click="newChat = true"
                class="text-capitalize mb-7 ml-4"
                large
                v-bind="attrs"
          v-on="on"
              >
                <v-icon> mdi-message-plus </v-icon>
              </v-btn>
                </template>
              <span>{{$t('tooltips.createNewChat')}}</span>
              </v-tooltip>
             
              <!-- <v-autocomplete
                v-model="searchTextModel"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                cache-items
                class="mx-4"
                flat
                hide-no-data
                hide-details
                label="What state are you from?"
                solo-inverted
              ></v-autocomplete> -->
            </v-card-title>
          </v-card>
        </v-flex>

        <!-- User List -->
        <v-flex
          xs4
          md4
          class="messageUserContainer pa-0"
          style="overflow-y: scroll; height: calc(100vh - 270px)"
        >
          <loading-progress :status="loadingStatus" />
          <v-list
            subheader
            v-if="$store.state.chatGroups.length > 0"
            :two-line="false"
            class="pa-0"
            style="background-color: transparent !important"
          >
            <v-list-item-group
              :value="isSelected"
              active-class="background-color: #E9E9E9"
            >
              <v-list-item
                v-for="(item, index) in (searchArray.length > 0 ? searchArray : $store.state.chatGroups)"
                v-if="item.user"
                :key="index"
                @click="selectMessageCard(item, index)"
                class="py-2"
                style="
                  border-bottom-color: #e2e2e4;
                  border-bottom-width: 1px;
                  border-bottom-style: solid;
                "
              >
                <v-list-item-avatar v-if="item.isOnline" size="65" class="pa-0 ma-0 mr-4">
                  <v-badge
                    bordered
                    bottom
                    color="green"
                    dot
                    offset-x="10"
                    offset-y="10"
                  >
                    <v-avatar size="50">
                      <v-img :src="item.user.avatar"></v-img>
                    </v-avatar>
                  </v-badge>
                </v-list-item-avatar>

                <v-list-item-avatar v-else size="65" class="pa-0 ma-0 mr-4">
                    <v-avatar size="50">
                      <v-img :src="item.user.avatar"></v-img>
                    </v-avatar>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>
                    <span
                      style="font-size: 13px"
                      class="font-weight-bold defaultColor--text mb-0"
                    >
                      {{ item.user.fullName }}
                      /
                    </span>
                    <span
                      style="font-size: 13px"
                      class="defaultColor--text mb-0 font-weight-regular"
                    >
                      <!-- <departmant-icon :departmentName="department" /> -->
                      {{ item.user.department }}
                    </span>
                  </v-list-item-title>

                  <v-list-item-subtitle class="mt-1">
                    <span
                      style="font-size: 13px"
                      class="defaultColor--text mr-2 font-weight-regular"
                      >{{
                        item.messages.length > 0 ? item.messages[0].message : ""
                      }}</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action
                  v-if="
                    item.messages.length > 0
                      ? item.messages[0].message == null
                        ? false
                        : !item.messages[0].isRead
                      : false
                  "
                >
                  <v-badge dot color="defaultColor"> </v-badge>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-flex>

        <!-- Message Screen -->
        <v-flex xs7 md7 pa-0 class="messageUserContainer">
          <v-card
            class="messageCardClass"
            style="
              background-color: transparent !important;
              border: 0px solid red !important;
            "
            flat
            v-if="selectedMessageGroup"
          >
            <v-card-title class="pa-0" style="border-bottom: 1px solid #dddddd">
              <v-list
                subheader
                two-line
                width="600"
                style="background-color: transparent !important"
              >
                <user-list-item
                  :item="selectedMessageGroup"
                  @sendMessage="(n) => (deleteDialog = true)"
                  :buttonText="'sil'"
                  :buttonType="'icon'"
                  buttonIconName="mdi-delete"
                  :buttonVisible="true"
                  :avatar="selectedMessageGroup.avatar"
                  :fullName="selectedMessageGroup.fullName"
                  :department="selectedMessageGroup.department"
                  :userId="selectedMessageGroup.id"
                  :company="selectedMessageGroup.company"
                  :noBg="true"
                  avatarSize="55"
                />
              </v-list>
            </v-card-title>
            <v-card-text
              id="container"
              style="overflow-y: scroll; height: calc(100vh - 450px)"
            >
              <loading-progress :status="chatRoomLoadingStatus" />
              <div v-for="(item, index) in chats" v-if="!chatRoomLoadingStatus">
                <!-- My Message -->
                <v-layout
                  v-if="$store.state.userId == item.userId"
                  justify-end
                  class="my-3 mx-2 ml-16"
                >
                  <v-card color="defaultColor rounded-tr-0 rounded-xl" flat>
                    <v-card-text class="white--text py-2 px6">
                      <div>{{ item.message }}</div>
                      <div v-if="!item.isRead" class="text-right">
                        <span
                          style="font-size: 10px"
                          class="mr-3 text--white"
                          >{{
                            moment(item.createdAt).locale("tr").fromNow()
                          }}</span
                        >
                        <v-icon color="white" size="12">mdi-check</v-icon>
                      </div>
                      <div v-else class="text-right">
                        <v-spacer />
                        <span
                          style="font-size: 10px"
                          class="mr-3 text--white"
                          >{{
                            moment(item.createdAt).locale("tr").fromNow()
                          }}</span
                        >
                        <v-icon color="white" size="16">mdi-check-all</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-layout>

                <!-- Other Message -->
                <v-layout v-else class="my-3 mx-2 mr-16">
                  <v-card
                    color="greyColorLigthFour rounded-tl-0 rounded-xl"
                    flat
                  >
                    <v-card-text class="defaultColor--text py-2 px6">
                      {{ item.message }}
                      <div class="text-left">
                        <v-spacer />
                        <span
                          style="font-size: 10px"
                          class="text--defaultColor"
                          >{{
                            moment(item.createdAt).locale("tr").fromNow()
                          }}</span
                        >
                      </div>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions class="pa-6">
              <v-layout row wrap align-center>
                <v-text-field
                  @keyup.enter="sendMessageChat"
                  ref="messageTextField"
                  :disabled="messageTextFieldProgress"
                  v-model.trim="messagetext"
                  flat
                  solo
                  rounded
                  color="defaultColor"
                  hide-details
                  single-line
                  outlined
                  full-width
                  :placeholder="$t('placeHolder.writeMessage')"
                >
                  <template v-slot:append>
                    <v-btn
                      @click="sendMessageChat"
                      :loading="messageTextFieldProgress"
                      outlined
                      rounded
                      class="text-capitalize mt-0"
                      color="defaultColor"
                      >{{ $t("feed.shares") }}</v-btn
                    >
                  </template>
                </v-text-field>
              </v-layout>
            </v-card-actions>

            <v-card class="mt-6" flat v-if="!selectedMessageGroup">
              <v-icon size="30">mdi-message-plus-outline</v-icon>
              <p class="text-center">
                {{ $t("description.selectUserToMessage") }}
              </p>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import MessageListItem from "../../components/Chat/MessageListItem.vue";
import UserListItem from "../../components/Users/UserListItem.vue";
import DialogCloseButton from "../../components/General/DialogCloseButton.vue";
import ContentService from "@/services/ContentService";
import ChatService from "@/services/ChatService";
import UserService from "@/services/UserService";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  data: () => {
    return {
      searchTextModel: "",
      loadingStatus: false,
      chatRoomLoadingStatus: false,
      userList: [],
      selectedMessageGroup: null,
      isSelected: -1,
      loading: false,
      items: [],
      messages: [],

      //Message Screen
      messagetext: "",
      messageTextFieldProgress: false,
      paginationStatus: false,
      container: "",

      //NewChat
      newChatUsers: [],
      newChat: false,
      newChatUserModel: "",
      newChatLoading: false,

      //Sayfa ilk yğklendiğinde servisten userlist çekiliyor. Sonrasında soketten okunuyor ki en son mesajlaştığı kişi en yukarıya gelsin.
      UserListSocketFlag: true,

      joinRoomId: null,

      deleteDialog: false,

      searchArray : []
    };
  },
  components: {
    LoadingProgress,
    MessageListItem,
    UserListItem,
    DialogCloseButton,
  },

  methods: {
    deleteChat() {
      console.log("joinroom id :", this.joinRoomId);
      ChatService.deleteChatRoom(this.joinRoomId)
        .then((res) => {
          this.selectedMessageGroup = null;
          const token = this.$store.state.token;
          this.getChatGroups(token);
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.deleteDialog = false;
        });
    },

    //Tüm kullanıcılarda arama yapar. Yeni bir chat oluşturmak için
    newChatSetUser() {
      this.newChatLoading = true;
      UserService.getUsers(this.newChatUserModel)
        .then((res) => {
          this.newChatUsers = res.data.Data;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.newChatLoading = false;
        });
    },

    //Seçilen yeni kullanıcı ile yeni bir chat oluşturulur.
    createNewChat(item) {
      let body = {
        userIds: [item.Id],
      };
      ChatService.createChatRoom(body)
        .then((res) => {
          const chatGroupId = res.data.Result.Id;
          this.joinRoom(chatGroupId)
            .then(() => {
              const token = this.$store.state.token;
              this.getChatGroups(token);
              this.closeNewChatDialog();
              setTimeout(() => {
                this.selectMessageCard(this.$store.state.chatGroups[0]);
              }, 1000);
            })
            .catch((err) => {
              console.log("err :", err);
              console.log("Can not join chat");
            });
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          this.chatRoomLoadingStatus = false;
        })
        .then(() => {
          this.chatRoomLoadingStatus = false;
        });
    },

    //User list dialoğu kapatıldığında tetiklenir.
    closeNewChatDialog() {
      this.newChatUsers = false;
      this.newChatUserModel = "";
      this.newChatLoading = false;
      this.newChat = false;
    },

    //Mesajlaşılan kişi listesinden biri seçildiğinde tetiklenir
    async selectMessageCard(item, index, type = "") {
      console.log("type  = ", type);
      console.log("item  = ", item);
      console.log("old join room id : ", this.joinRoomId);
      this.chatRoomLoadingStatus = true;
      if (this.joinRoomId) {
        this.outRoom(this.joinRoomId);
        console.log("Çıktııııııııı");
      }
      //this.chatRoomLoadingStatus = true;
      console.log("selected item : ", item);
      this.selectedMessageGroup = item.user;
      this.joinRoomId = item.id;
      console.log("new join room id : ", this.joinRoomId);
      console.log("user : ", this.selectedMessageGroup);
      //this.selectedMessageGroup = type == 'createChat' ? user : item.user;

      if (index == this.isSelected) {
        this.selectedMessageGroup = null;
        this.isSelected = -1;
      }
      //this.createChatRoom(item);
      this.joinRoom(this.joinRoomId)
        .then(() => {
          this.chatRoomLoadingStatus = false;
          this.scrollToEnd();
        })
        .catch((err) => {
          console.log("err :", err);
          console.log("Can not join chat");
        });
      // await this.getNotReadMessages(token).then(() => {
      // });
    },

    //Yeni bir mesajlaşama grubu oluşturur (Kişi)
    createChatRoom(item) {
      console.log("itemmm : ", item);
      let body = {};
      body.userIds = [item.Id];
      console.log("body : ", body);
      ContentService.createChatRoom(body)
        .then((res) => {
          const chatGroupId = res.data.Result.Id;
          this.joinRoom(chatGroupId)
            .then(() => {
              this.scrollToEnd();
            })
            .catch((err) => {
              console.log("err :", err);
              console.log("Can not join chat");
            });
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          this.chatRoomLoadingStatus = false;
        })
        .then(() => {
          this.chatRoomLoadingStatus = false;
        });
    },

    //Sayfa ilk yüklendiğinde kullanıcının mesajlarını ve mesajlaştığı kişileri döndürür
    async getUserMessages() {
      this.chatRoomLoadingStatus = true;
      this.getChatBox();
    },

    //Socketten Mesajlaşılan kişiler döner
    getChatBoxSocket() {
      const token = this.$store.state.token;
      this.getChatGroups(token);
    },

    //Mesajlaşılan kişilerin listesini döndürür
    getChatBox() {
      ChatService.getChatBox()
        .then((res) => {
          console.log("get checkBox : ", res.data);
          //this.$store.state.chatGroups = res.data.Result
          let data = res.data.Result;
          let arr = [];
          data.forEach((element) => {
            arr.push(element.Users[0]);
          });
          console.log("arr :", arr);
          //this.$store.state.chatGroups = arr;
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {});
    },

    //Mesaj gönderme
    sendMessageChat() {
      this.sendMessage(this.messagetext)
        .then(() => {
          this.container = document.querySelector("#container");
          this.paginationStatus = false;
          (this.messagetext = ""), this.scrollToEnd();
        })
        .catch((err) => {
          console.log("err :", err);
          console.log("Can not join chat");
        });
    },

    //Chat ekranının scroll positionını en alta indirir
    scrollToEnd() {
      this.container = document.querySelector("#container");
      this.$nextTick(() => {
        //console.log('scrool end yapıldı : ', this.container)
        this.container.scrollTop = this.container.scrollHeight;
      });
    },

    //Pagination olursa diye scroll top olduğunda tetiklenir
    scrollTop(e) {
      if (this.container.scrollTop === 0) {
        //Mesajlara pagination eklendiğinde burayada eklenecek;
      }
    },

    //Mesajlaşılan kişilerde arama yapar.
    searchChatBox() {
      //TODO: Eklenecek
    },

    ...mapActions([
      "getChatGroups",
      "joinRoom",
      "getNotReadMessages",
      "sendMessage",
      "outRoom",
    ]),
  },
  computed: {
    ...mapState(["chats"]),
  },
  destroyed() {
    if (this.joinRoomId) {
      this.outRoom(this.joinRoomId);
    }
  },
  mounted() {
  },
  watch: {
    messages() {
      if (this.paginationStatus === false) {
        this.$nextTick(() => {
          this.scrollToEnd();
        });
      }
    },
    chats(newValue, oldValue) {
      this.scrollToEnd();
    },
    searchTextModel(newValue, oldValue) {
      if(newValue == ''){
        this.searchArray = [];
      }
      else if(newValue != oldValue) {
        this.searchArray = this.$store.state.chatGroups;

        this.searchArray = this.$store.state.chatGroups.filter((item) => {
          return item.user.fullName
            .toLowerCase()
            .includes(newValue.toLowerCase());
        });
      }
    },
  },
};
</script>

<style></style>
